var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('q-btn',{attrs:{"flat":"","icon":"bug_report","color":_vm.iconColor},on:{"click":function($event){_vm.debug = !_vm.debug}}},[_c('q-tooltip',[_vm._v(" "+_vm._s(_vm.$t('debugText.debugButtonExplanation'))+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }